// extracted by mini-css-extract-plugin
module.exports = {"container":"Gosuslugy_container__3x6TK","filters":"Gosuslugy_filters__1Vyao"};